import * as React from "react";
import { singleton } from "logic/singleton";
const initialState = {
  activeStepKey: "",
  backendValidationErrors: void 0,
  authBackendMeta: { serviceType: "", serviceTitle: "" },
  formValues: {},
  invalidStepKeys: [],
  setStepsState: () => {
  }
};
const BackendWizardContext = React.createContext(initialState);
export default singleton("contexts.authentication.directoryServices.backendWizard", () => BackendWizardContext);
